const version = '4.0.4'

export { version }